module.exports = __webpack_public_path__ + "assets/img/block-right-7cecdae0.png";